const getAttribute = (meta, attribute) => {
    let el = meta.attributes.filter(att => att.trait_type===attribute)
    if(el.length===0) return null
    return el[0].value 
}

export {getAttribute}